<mat-card
    class="daxa-card recent-orders-card mb-25 border-radius bg-white border-none d-block p-3"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative ">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-none outline-0 rounded-pill"
                       placeholder="Chercher un terrain..."
                       (keyup)="applyFilter($event)">
            </form>
        </mat-card-title>
        <mat-card-subtitle>
            <button class="btn btn-primary btn-sm rounded-start-pill" (click)="openNewTerrainForm(content)">
                <span class="px-2">Nouveau</span>
            </button>
            <button class="btn btn-outline-primary btn-sm rounded-end-pill" [matMenuTriggerFor]="menu"
                    aria-haspopup="true" aria-expanded="false" id="dropdownMenuClickableInside">
                <i class="fa-solid fa-table px-3"></i>
            </button>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort>
                    <!-- Name Column -->
                    <ng-container matColumnDef="varPlante">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Culture</th>
                        <td mat-cell *matCellDef="let element"> {{ element.varPlante }}</td>
                    </ng-container>
                    <!-- Name Column -->
                    <ng-container matColumnDef="datePlantation">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date de plantation</th>
                        <td mat-cell *matCellDef="let element"> {{ element.datePlantation }}</td>
                    </ng-container>
                    <!-- Name Column -->
                    <ng-container matColumnDef="actif">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Statut</th>
                        <td mat-cell *matCellDef="let element"> {{ element.actif ? 'Actif' : 'Inactif' }}</td>
                    </ng-container>
                    
                    <ng-container matColumnDef="creationDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Crée le</th>
                        <td mat-cell *matCellDef="let element"> {{ element.creationDate }}</td>
                    </ng-container>

                    <ng-container matColumnDef="identification">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Client</th>
                        <td mat-cell *matCellDef="let element"> {{ element.identification }}</td>
                    </ng-container>
                    <ng-container matColumnDef="producteur">
                        
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Producteur</th>
                        <td mat-cell *matCellDef="let element"> {{ element.producteur }}</td>
                    </ng-container>
                    <!-- Update Date Column -->
                    <ng-container matColumnDef="updateDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Modifié le</th>
                        <td mat-cell *matCellDef="let element"> {{ element.updateDate }}</td>
                    </ng-container>
                    <ng-container matColumnDef="exploitationId">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Exploitation</th>
                        <td mat-cell *matCellDef="let element"> {{ element.exploitationName }} </td>
                    </ng-container>

                    <!-- Actions -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Actions</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-info text-center" style="justify-content: center !important;">
                                <button type="button" mat-button matTooltip="Visualiser" matTooltipPosition="above"
                                        (click)="openViewModel(element)">
                                    <i class="material-symbols-outlined">
                                        visibility
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Modifier" matTooltipPosition="above"
                                        (click)="openEditModal(element)">
                                    <i class="material-symbols-outlined text-primary">
                                        brush
                                    </i>
                                </button>
                                <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above"
                                        (click)="confirmDelete(element)">
                                    <i class="material-symbols-outlined text-danger">
                                        delete
                                    </i>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="getdisplayedCol()"></tr>
                    <tr mat-row *matRowDef="let row; columns: getdisplayedCol();"></tr>

                    <div *ngIf="!loadingTable">
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="15">Aucun résultat trouvé pour les terrains</td>
                    </tr>
                    </div>

                </table>

                <div *ngIf="loadingTable">
                    <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                        <span class="skeleton-cell"></span>
                    </div>
                </div>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </mat-card-content>
</mat-card>


<!-- Add modal template for editing -->
<ng-template #editModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    Modifier le terrain
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="editTerrainForm" (ngSubmit)="updateTerrain()">
                <div class="row">
                    <div class="col-lg-4">
                        <!-- Var Plante Field -->
                        <mat-form-field class="mb-25">
                            <mat-label>Culture</mat-label>
                            <input matInput formControlName="varPlante" placeholder="Ex. Variety 1">
                        </mat-form-field>

                        <input type="hidden" formControlName="creationDate">
                        <input type="hidden" formControlName="idCreatedBy">
                        <input type="hidden" formControlName="id">
                        <mat-form-field class="mb-25">
                            <mat-label>Creé le</mat-label>
                            <input readonly matInput formControlName="creationDate">
                        </mat-form-field>
                        <!-- Date Plantation Field -->
                        <mat-form-field class="mb-25">
                        <mat-label>Date de Plantation</mat-label>
                        <input matInput readonly [matDatepicker]="picker" formControlName="datePlantation"
                                placeholder="Ex. 28/09/2024">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        <mat-error *ngIf="terrainForm.get('datePlantation')?.hasError('required')">Champ obligatoire</mat-error>
                        </mat-form-field>

                        <div class="col-lg-12">
                            <mat-form-field class="mb-25">
                                <mat-label>Producteur</mat-label>
                                <input matInput formControlName="producteur" placeholder="Ex. ferme 01">

                            </mat-form-field>
                        </div>
                        <!-- Status Field -->
                        <mat-form-field class="mb-25">
                            <mat-label>Statut</mat-label>
                            <mat-select formControlName="actif">
                                <mat-option [value]="true">Actif</mat-option>
                                <mat-option [value]="false">Inactif</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <!-- Client Field -->
                        <mat-form-field class="mb-25">
                            <mat-label>Client</mat-label>
                            <mat-select formControlName="clientId" placeholder="Selectionner le client">
                                <mat-option *ngFor="let client of clientList" [value]="client.id">
                                    {{ client.socialReason }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="editTerrainForm.get('clientId')?.hasError('required')">Champ
                                obligatoire
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="mb-25">
                            <mat-label>Exploitation</mat-label>
                            <mat-select formControlName="exploitationId" placeholder="Selectionner l'exploitation">
                                <mat-option *ngFor="let expl of exploitationList" [value]="expl.id">
                                    {{ expl.name }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="editTerrainForm.get('exploitationId')?.hasError('required')">Champ
                                obligatoire
                            </mat-error>
                        </mat-form-field>
                        <!-- Description Field -->
                        <mat-form-field class="mb-25">
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description"
                                      placeholder="Ex. Terrain contaminé"></textarea>
                            <mat-error *ngIf="editTerrainForm.get('description')?.hasError('required')">Champ
                                obligatoire
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-8">
                        <div class="row">
                            <mat-form-field class="mb-25 col-sm-6">
                                <mat-label>Latitude</mat-label>
                                <input type="number" matInput
                                       [(ngModel)]="coordonnes.latitude" [value]="coordonnes.latitude"
                                       (ngModelChange)="updateCoordonnees()"
                                       [ngModelOptions]="{standalone: true}"
                                       >
                            </mat-form-field>
                            <mat-form-field class="mb-25 col-sm-6">
                                <mat-label>Longitude</mat-label>
                                <input type="number" matInput
                                       [(ngModel)]="coordonnes.longitude" [value]="coordonnes.longitude"
                                       (ngModelChange)="updateCoordonnees()"
                                       [ngModelOptions]="{standalone: true}"
                                       >
                            </mat-form-field>
                        </div>
                        <div id="edit-modal-map" style="height: 410px; width: auto"></div>

                    </div>
                    <!-- Submit Button -->
                    <div class="col-sm-12 text-right mt-3">
                        <button type="submit" class="btn btn-outline-primary btn-sm">Enregistrer</button>
                    </div>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>

<!-- modal template for new -->
<ng-template #content let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">Nouveau terrain</h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="terrainForm" (ngSubmit)="saveTerrain()">
                <div class="row">
                    <div class="row col-lg-4 d-flex justify-content-between">
                        <!-- Client Field -->
                        <div class="col-lg-12">
                            <mat-form-field class="mb-25">
                                <mat-label>Liste des clients</mat-label>
                                <mat-select formControlName="clientId" placeholder="Selectionner le client">
                                    <mat-option *ngFor="let client of clientList" [value]="client.id">
                                        {{ client.socialReason }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="terrainForm.get('clientId')?.hasError('required')">Champ obligatoire
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <mat-form-field class="mb-25">
                            <mat-label>Exploitation</mat-label>
                            <mat-select formControlName="exploitationId" placeholder="Selectionner l'exploitation">
                                <mat-option *ngFor="let expl of exploitationList" [value]="expl.id">
                                    {{ expl.name }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="editTerrainForm.get('exploitationId')?.hasError('required')">Champ
                                obligatoire
                            </mat-error>
                        </mat-form-field>
                        <!-- Var Plante Field -->
                        <div class="col-lg-12">
                            <mat-form-field class="mb-25">
                                <mat-label>Culture</mat-label>
                                <input matInput formControlName="varPlante" placeholder="Ex. Variety 1">
                                <mat-error *ngIf="terrainForm.get('varPlante')?.hasError('required')">Champ
                                    obligatoire
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-12">
                            <mat-form-field class="mb-25">
                                <mat-label>Producteur</mat-label>
                                <input matInput formControlName="producteur" placeholder="Ex. ferme01">
                            </mat-form-field>
                        </div>
                        <!-- Date Plantation Field -->
                        <div class="col-lg-12">
                            <mat-form-field class="mb-25">
                                <mat-label>Date de Plantation</mat-label>
                                <input matInput readonly [matDatepicker]="picker"
                                       formControlName="datePlantation"
                                       placeholder="Ex. 2024-09-28">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                                <mat-error *ngIf="terrainForm.get('datePlantation')?.hasError('required')">Champ
                                    obligatoire
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Status Field -->
                        <div class="col-lg-12">
                            <mat-form-field class="mb-25">
                                <mat-label>Statut</mat-label>
                                <mat-select formControlName="actif">
                                    <mat-option [value]="true">Actif</mat-option>
                                    <mat-option [value]="false">Inactif</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <!-- Description Field -->
                        <div class="col-lg-12">
                            <mat-form-field class="mb-25">
                                <mat-label>Description</mat-label>
                                <textarea matInput formControlName="description"
                                          placeholder="Ex. Terrain contaminé"></textarea>
                                <mat-error *ngIf="terrainForm.get('description')?.hasError('required')">Champ
                                    obligatoire
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row col-lg-8">
                        <div class="col-sm-6">
                            <mat-form-field class="mb-25">
                                <mat-label>Latitude</mat-label>
                                <input type="number" matInput
                                       [(ngModel)]="coordonnes.latitude" [value]="coordonnes.latitude"
                                       (ngModelChange)="updateCoordonnees()"
                                       [ngModelOptions]="{standalone: true}" >
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field class="mb-25">
                                <mat-label>Longitude</mat-label>
                                <input type="number" matInput
                                       [(ngModel)]="coordonnes.longitude" [value]="coordonnes.longitude"
                                       (ngModelChange)="updateCoordonnees()"
                                       [ngModelOptions]="{standalone: true}">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12">
                            <div id="map-for-new-modal" style="height: 410px; width: auto"></div>
                        </div>
                        <!-- Submit Button -->
                        <div class="col-sm-12 text-right mt-3">
                            <button type="submit" class="btn btn-outline-primary btn-sm">Enregistrer</button>
                        </div>
                    </div>
                </div>
            </form>
        </mat-card-content>

    </mat-card>
</ng-template>

<!-- modal template for infos -->
<ng-template #viewModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0 fw-bold">
                    Détails du terrain
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>

            <div class="row">
                <hr>
                <div class="col-lg-4">
                    <!-- creationDate -->
                    <div class="col-sm-6 ">
                        <div>
                            <div class="fw-bold">Creé le :</div>
                            <p>{{ this.terrainModel.creationDate }}</p>
                        </div>
                    </div>
                    <hr>
                    <!-- nameCreatedBy -->
                    <div class="col-sm-12">
                        <div class="fw-bold">Creé par :</div>
                        <p>{{ this.terrainModel.nameCreatedBy}}</p>
                    </div>
                    <hr>

                    <!-- updateDate -->
                    <div class="col-sm-12">
                        <div class="fw-bold">Modifié le :</div>
                        <p>{{ this.terrainModel.updateDate }}</p>
                    </div>
                    <hr>

                    <!-- varPlante -->
                    <div class="col-sm-12 ">
                        <div class="fw-bold">Culture :</div>
                        <p>{{ this.terrainModel.varPlante }}</p>
                    </div>
                    <hr>

                    <!-- Active -->
                    <div class="col-sm-12">
                        <div class="fw-bold">Active :</div>
                        <p>{{ this.terrainModel.actif}}</p>
                    </div>
                    <hr>

                    <!-- Client  -->
                    <div class="col-sm-12">
                        <div class="fw-bold">Client :</div>
                        <p>{{ this.terrainModel.identification }}</p>
                    </div>
                    <hr>

                    <!-- Description -->
                    <div class="col-sm-12">
                        <div class="fw-bold">Description :</div>
                        <p>{{ this.terrainModel.description }}</p>
                    </div>
                </div>
                <div class="col-lg-8 row border-start ">
                    <div class="col-sm-6">
                        <div class="fw-bold">Longitude :</div>
                        <p>{{ this.terrainModel.lon }}</p>
                    </div>

                    <div class="col-sm-6">
                        <div class="fw-bold">Latitude :</div>
                        <p>{{ this.terrainModel.lat }}</p>
                    </div>
                    <div class="col-sm-12"  style="height: 470px;" id="map-view-modal"></div>

                </div>





            </div>


        </mat-card-content>
    </mat-card>
</ng-template>

<!-- Menu with Checkboxes -->
<mat-menu #menu="matMenu">
    <div class="scrollable-menu shadow-lg bg-body">
        <mat-checkbox [checked]="displayedColumns.length == columns.length" (change)=" handleIsAllColsSelected($event)"
                      (click)="$event.stopPropagation()">Tous
        </mat-checkbox>
        @for (col of columns; track $index) {
            <div>
                <mat-checkbox [value]="col"
                              [checked]="displayedColumns.includes(col) || displayedColumns.length == columns.length"
                              (click)="$event.stopPropagation(); onSelectionChange(col)">
                    {{ col }}
                </mat-checkbox>
            </div>
        }
    </div>

</mat-menu>



